import { render } from "./F2ImageOrVideo.vue?vue&type=template&id=08889e7a&scoped=true&ts=true"
import script from "./F2ImageOrVideo.vue?vue&type=script&lang=ts"
export * from "./F2ImageOrVideo.vue?vue&type=script&lang=ts"

import "./F2ImageOrVideo.vue?vue&type=style&index=0&id=08889e7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08889e7a"]])

export default __exports__